import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseServiceWithFilter } from './base.service';
import { WorkType } from '@cl/shared/models/works/work-type.model';
import { CommandResult } from '@cl/shared/models/misc/command-result.model';
import { Observable } from 'rxjs';
import { WorkTypeFilter } from '@cl/shared/models/works/work-type-filter.model';

@Injectable({ providedIn: 'root' })
export class WorkTypesService extends BaseServiceWithFilter<WorkType, WorkTypeFilter> {
    constructor(httpClient: HttpClient) {
        super(httpClient, '/api/v1/work-types/');
    }

    getWorkTypesForOrder(orderTypeId: number): Observable<CommandResult<WorkType[]>> {
        return this.httpClient.get<CommandResult<WorkType[]>>(`${this.baseApiUrl}order-type/${orderTypeId}`);
    }

    getEstimateItemsForOrder(orderTypeId: number): Promise<CommandResult<WorkType[]>> {
        return this.httpClient.get<CommandResult<WorkType[]>>(`${this.baseApiUrl}order-type/${orderTypeId}/include-estimate-items`).toPromise();
    }

    toString(object: WorkType): string {
        return `${object.name} (${object.ordersTypeName})`;
    }
}
